export const environment = {
  production: false,
  backendApiUrl: 'https://api.auto-dev.aws.private-pmideep.biz/api/v1',
  msalConfig: {
    auth: {
      clientId: '3641d4ad-05dd-4fe9-8361-7ea96803e8b6',
      authority: 'https://login.microsoftonline.com/8b86a65e-3c3a-4406-8ac3-19a6b5cc52bc',
      redirectUri: 'https://auto-dev.aws.pmicloud.biz/'
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowNativeBroker: false,
      logLevel: 'Info',
      piiLoggingEnabled: false,
    }
  },
  apiConfig: {
    uri: 'https://graph.microsoft.com/v1.0/me',
    protectedResources: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read', 'group.read.all']
      }
    ]
  },
  nodeScopes: {
    READ: ['user.read'],
    READ_ALL: ['group.read.all'],
    FEA: ['api://857ff85c-0f16-4169-9a3c-1bfb4b5528ce/session:role-any'],
    FCD: ['api://1524d690-d025-44ea-ab0b-651df23e6b9c/session:role-any'],
    FCT: ['api://26819e7d-579e-456c-8f7a-b0d9a933fee7/session:role-any'],
    DPS: ['api://188dc1fd-ab80-44fc-a941-cf300d27e41d/session:role-any'],
    DPT: ['api://5bb168c0-b734-4a8e-8751-1a7807a97626/session:role-any'],
    KR: ['api://8f76976a-7bdc-4974-abd3-9bb89a52ebea/session:role-any']
  },
  routes: {
    loginFailedRoute: '/login'
  }
};
